import { ImgProps } from "assets/images/types";

export default function ImgVivo(props: ImgProps) {
	const { height = 30, width = 88 } = props;
	return (
		<img
			src="/assets/images/companies/vivo.webp"
			alt="Vivo logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
